export default {
  // type: {
  //   unDocumented: {
  //     issues: [
  //       { id: 'I-DEM-PN-2300',
  //         domain: 'DPAE',
  //         isDynamic: true,
  //         dynamicParameters: { organization: 'name' }
  //       }
  //     ]
  //   }
  // },
  // name: {
  //   unDocumented: {
  //     issues: [
  //       { id: 'I-DEM-PN-2400',
  //         domain: 'DPAE'
  //       }
  //     ]
  //   }
  // },
  access: {
    issues: [
      {
        id: 'I-DEM-PN-2500',
        domain: 'DPAE',
        isDynamic: true,
        dynamicParameters: { name: 'name' }
      }
    ],
    triggerValue: 'no'
  }
  // address1: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-2600",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // },
  // city: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-2700",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // },
  // state: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-2800",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // },
  // zip: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-2900",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // },
  // phoneType: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-3000",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // },
  // phone: {
  //   unDocumented: {
  //     issues: [
  //       {
  //         id: "I-DEM-PN-3100",
  //         domain: "DPAE",
  //         isDynamic: true,
  //         dynamicParameters: { name: "name" }
  //       }
  //     ]
  //   }
  // }
}
